import React, { useEffect, useRef, useState } from 'react';

function SideBar({ theme, onThemeChange }) {
    const [menuOpen, setMenuOpen] = useState(false);
    const menuButton = useRef(null);
    const nav = useRef(null);

    useEffect(() => {
        if (!menuOpen) return undefined;
        nav.current.querySelector('a').focus();
        const closeOnEscape = event => {
            if (event.key === 'Escape') {
                setMenuOpen(false);
                menuButton.current.focus();
            }
        };
        document.addEventListener('keydown', closeOnEscape);
        return () => document.removeEventListener('keydown', closeOnEscape);
    }, [menuOpen]);

    const navigate = event => {
        setMenuOpen(false);
        const target = document.querySelector(event.currentTarget.hash);
        if (target) target.focus({ preventScroll: true });
    };

    return (
        <header className="site-header">
            <div className="header-inner container">
                <a className="brand" href="#home" aria-label="Andrew Kasper, home">
                    <span className="monogram" aria-hidden="true">ak<span>.</span></span>
                    <span>Andrew Kasper</span>
                </a>
                <nav id="primary-navigation" ref={nav} className={`primary-nav${menuOpen ? ' is-open' : ''}`} aria-label="Main navigation" onBlur={event => {
                    if (!event.currentTarget.contains(event.relatedTarget) && event.relatedTarget !== menuButton.current) setMenuOpen(false);
                }}>
                    <a href="#work" onClick={navigate}>Selected work</a>
                    <a href="#about" onClick={navigate}>About</a>
                    <a href="#contact" onClick={navigate}>Get in touch <span aria-hidden="true">↗</span></a>
                </nav>
                <div className="header-controls">
                    <button className="theme-button" type="button" onClick={onThemeChange} aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}>
                        {theme === 'light' ? <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.5 14A8.5 8.5 0 0 1 10 3.5 8.5 8.5 0 1 0 20.5 14Z" /></svg> : <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="4"/><path d="M12 2v2m0 16v2M2 12h2m16 0h2M5 5l1.5 1.5m11 11L19 19M5 19l1.5-1.5m11-11L19 5"/></svg>}
                    </button>
                    <button ref={menuButton} className="menu-button" type="button" aria-expanded={menuOpen} aria-controls="primary-navigation" onClick={() => setMenuOpen(!menuOpen)}>{menuOpen ? 'Close' : 'Menu'}<span aria-hidden="true">{menuOpen ? ' ×' : ' ☰'}</span></button>
                </div>
            </div>
        </header>
    );
}

export default SideBar;
